import { ItemRule } from 'src/types/menu.types';

export const getRulesCount = (rule: ItemRule) => {
  const conditions = [rule.consumer_name, rule.description, rule.assets && rule.assets.length > 0, rule.plu];
  return conditions.reduce((count, condition) => count + (condition ? 1 : 0), 0);
};
